export function GetSpGlobalContext() {
  if ((window as any)["_spPageContextInfo"]) {
    return (window as any)["_spPageContextInfo"];
  }
}

export function GetUserLoginNameFromSpGlobgalContext() {
  return GetSpGlobalContext()?.userLoginName;
}
